/* eslint-disable no-undef */
export const chatLoader = (token) => {
  // window.isChatHide = true;
  window.support = true;
  function initializeChatWidget(e) {
    console.log("Chat LOADED:", e);
  }
  const lang = localStorage.getItem("lang") || "en";
  const newDiv = document.createElement("div");
  if (!document.getElementById("root")) {
    const newDiv = document.createElement("div");
    newDiv.id = "root";
    document.body.appendChild(newDiv);
  }
  document.body.appendChild(newDiv);
  // const protocols =
  //   window.location.protocol === "http:"
  //     ? "www.sync.wizztech.us"
  //     : "sync.wizztech.us";
  // console.log("protocol", protocols);
  WizzUtils.componentLoader({
    // bucketName: protocols,
    // region: "me-central-1",
    url: "https://sync.wizztech.us",
    func: initializeChatWidget,
    params: {
      language: lang,
      token
    },
  });
};
